import {Box, Typography} from '@mui/material';
import {tooltipBox, tooltipMonth, tooltipLabel, tooltipValue} from './styles';

interface TooltipContentProps {
  month: string;
  revenue: number;
  estimatedRevenue: number;
  bookingRate: number;
  isFuture: boolean;
}

const TooltipContent: React.FC<TooltipContentProps> = ({
  month,
  revenue,
  estimatedRevenue,
  bookingRate,
  isFuture,
}) => (
  <Box sx={tooltipBox}>
    <Typography variant="h6" sx={tooltipMonth}>
      {month}
    </Typography>
    <Typography sx={tooltipLabel}>
      {isFuture ? 'Estimated revenue' : 'Revenue'}
    </Typography>
    <Typography sx={tooltipValue}>
      £
      {isFuture
        ? estimatedRevenue?.toLocaleString()
        : revenue?.toLocaleString()}
    </Typography>
    <Typography sx={tooltipLabel}>Booking rate</Typography>
    <Typography sx={tooltipValue}>{bookingRate}%</Typography>
  </Box>
);

export default TooltipContent;
